import type { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import type { MouseEventHandler, ReactNode } from 'react';

type ButtonWidth = '5rem' | '10rem' | '15rem' | '20rem' | '100%';

interface Props {
  id?: string;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'error' | 'warning';
  width?: ButtonWidth;
  size?: 'small' | 'medium' | 'large';
  isLoading?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function Button({
  id,
  variant = 'contained',
  color = 'primary',
  width,
  size = 'medium',
  isLoading = false,
  startIcon,
  endIcon,
  onClick,
  children,
  type = 'button',
  disabled,
  sx,
}: Props) {
  return (
    <Box display="inline-flex" flexDirection="column" width={width} maxWidth="100%">
      <MuiButton
        id={id}
        variant={variant}
        color={color}
        size={size}
        disabled={disabled || isLoading}
        startIcon={startIcon}
        endIcon={endIcon}
        onClick={onClick}
        type={type}
        sx={{
          width,
          maxWidth: '100%',
          ...(sx || {}),
        }}
      >
        {children}
      </MuiButton>

      {isLoading && (
        <LinearProgress sx={{ mt: '-4px', h: '4px', borderRadius: ' 0 0 4px 4px', width }} />
      )}
    </Box>
  );
}
